import styled from "styled-components";
import React, { useState, useEffect, useCallback } from "react";

import { SearchIcon } from "../Svg";

const SearchBarWrapper = styled.label`
  position: relative;
  display: block;

  & svg {
    position: absolute;
    top: 9px;
    left: 10px;
    color: #b2b2b2;
  }
`;

const SearchBarInput = styled.input`
  width: 100%;
  height: 40px;
  border: none;
  padding-left: 42px;
  border-radius: 6px;
  background: #f2f2f2;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
  color: #5e646d;
  &:focus,
  &:active {
    border: none;
  }
`;

const SearchBar = ({ defaultText = "", debounce = 0, onChange, disabled }) => {
  const [searchText, setSearchText] = useState(defaultText);

  useEffect(() => {
    const handler = setTimeout(() => {
      onChange(searchText);
    }, debounce);
    return () => {
      clearTimeout(handler);
    };
  }, [searchText, debounce, onChange]);

  const updateSearchText = useCallback((event) => setSearchText(event.target.value), []);
  const handleSearchFocus = useCallback((event) => event.target.select(), []);

  return (
    <SearchBarWrapper>
      <SearchIcon />
      <SearchBarInput
        disabled={disabled}
        type="text"
        value={searchText}
        onChange={updateSearchText}
        onFocus={handleSearchFocus}
      />
    </SearchBarWrapper>
  );
};

export default SearchBar;
